import { environmentData } from "@/helper/environment";
import { getJwtToken } from "@/utils/common";
import { HttpError } from "@/utils/http_error";

export const getHeaders = (key: string, sendToken = false): Headers => {
  const headers = new Headers();
  headers.append("Accept", "application/json");
  headers.append("Consumer-Key", key);
  if (sendToken) {
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${getJwtToken("access_token")}`);
  }
  return headers;
};

export class HttpClient {
  ongoingRequests: Map<string, Promise<any>> = new Map();
  /**
   * Sends a GET request to the specified URL.
   * @param url The URL to send the request to.
   * @param method The HTTP method to use (default: "GET").
   * @returns A promise that resolves to the API response.
   * @throws If an error occurs during the request.
   */
  async get(url: string, journeyName = ""): Promise<any> {
    const key = environmentData.cdhAPIConsumerKey;
    const watchlistkey = environmentData.saveContainerAPIConsumerKey;

    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(journeyName === "watchlistAPI" ? watchlistkey : key, journeyName === "watchlistAPI")
    });

    if (!response.ok) {
      const errorText = await response.text(); // Try to get error details
      console.error(`API Error: ${response.status} - ${errorText}`);
      if (response.status === 404) {
        return [];
      } else {
        throw HttpError.getErrorString(response.status);
      }
    }
    return await response.json();
  }

  /**
   * Sends a POST request to the specified URL.
   * @param url The URL to send the request to.
   * @param body The request payload.
   * @param headers Optional additional headers.
   * @returns A promise that resolves to the API response.
   * @throws If an error occurs during the request.
   */
  async post(url: string, payload: any): Promise<any> {
    const key = environmentData.saveContainerAPIConsumerKey;

    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(key, true),
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw HttpError.getErrorString(response.status);
    }

    return await response.json();
  }
}

export const httpClient = new HttpClient();
